import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PDFDocument } from 'pdf-lib';
import { BehaviorSubject, Observable } from 'rxjs';
import { AppConstants } from '../../../config/app-constants';
import { REPORTS_API_ENDPOINTS } from '../../../endpoints.const';
import { LoaderService } from '../../core/services/loading.service';

@Injectable({
  providedIn: 'root'
})
export class ReportsService {
  private apiUrl = AppConstants.APP_BASE_API_URL;

  showFilter: BehaviorSubject<any> = new BehaviorSubject<any>(false);
  showModify = false;

  constructor(public http: HttpClient, public loaderService: LoaderService) { }

  getAllReports(payload) {
    const headers = new HttpHeaders({
      'userId': this.loaderService.getItem('userId'),
    });
    let url = `${AppConstants.APP_BASE_API_URL}${REPORTS_API_ENDPOINTS.GET_ALL_REPORTS}`
    return this.http.post(url, payload)
  }
  getApplicationId() {
    const encodedId = this.loaderService.getItem('appAccountDetailId');
    if (!encodedId) return null;

    const decodedId = encodedId;
    return Number(decodedId) === 0 ? null : decodedId;
  }
  downloadReportPdf(reportQueueId: number): Observable<Blob> {
    const headers = new HttpHeaders({
      userId: this.loaderService.getItem('userId') || ''
    });

    const url = `${AppConstants.APP_BASE_API_URL}export`;

    const body = {
      reportFormat: 'PDF',
      reportType: 'PRINT_REPORT',
      reportsRequest: {
        reportQueueId
      }
    };
    return this.http.post(url, body, {
      responseType: 'blob'
    });
  }
  downloadReportHtml(reportQueueId: number): Observable<Blob> {
    const headers = new HttpHeaders({
      userId: this.loaderService.getItem('userId') || ''
    });

    const url = `${AppConstants.APP_BASE_API_URL}export`;

    const body = {
      reportFormat: "HTML",
      reportType: "PRINT_HTML_REPORT",
      reportsRequest: {
        reportQueueId
      }
    }
    return this.http.post(url, body, {
      responseType: 'blob'
    });
  }
  downloadReportExcel(reportQueueId: number, msgKeyId?: string, reportRequestId?: number): Observable<Blob> {
    const headers = new HttpHeaders({
      userId: this.loaderService.getItem('userId') || ''
    });

    const url = `${AppConstants.APP_BASE_API_URL}export`;
    let body = {};
    if (msgKeyId === 'loss.triangle') {
      body = {
        reportType: "LOSS_TRI_EXCEL",
        reportFormat: "EXCEL",
        reportsRequest: {
          organizationId: this.loaderService.getItem('orgId'),
          applicationAccntDtlId: this.getApplicationId(),
          reportRequestId: reportRequestId,
          customReport: {
            accountName: this.loaderService.getItem('accountName')
          }
        }
      }
    } else {
      body = {
        reportFormat: "EXCEL",
        reportType: "PRINT_EXCEL_REPORT",
        reportsRequest: {
          reportQueueId
        }
      }
    }
    return this.http.post(url, body, {
      responseType: 'blob'
    });
  }

  generateCalendarExcelReport(payload: any): Observable<Blob> {
    const headers = new HttpHeaders({
      userId: this.loaderService.getItem('userId') || ''
    });

    const url = `${AppConstants.APP_BASE_API_URL}${REPORTS_API_ENDPOINTS.CALENDAR_EXCEL_EXPORT}`;

    return this.http.post(url, payload, {
      responseType: 'blob'
    });
  }
  generateCalendarExcelDownload(reportType: string, payload: any) {
    return this.generateCalendarExcelReport(payload).pipe();
  }

  addCustomReport(payload: any): Observable<any> {
    const headers = new HttpHeaders({
      userId: this.loaderService.getItem('userId') || ''
    });

    const url = `${AppConstants.APP_BASE_API_URL}${REPORTS_API_ENDPOINTS.GET_ALL_REPORTS}`;

    return this.http.post(url, payload);
  }

  putAllReports(payload) {
    const headers = new HttpHeaders({
      'userId': this.loaderService.getItem('userId'),
    });
    let url = `${AppConstants.APP_BASE_API_URL}${REPORTS_API_ENDPOINTS.GET_ALL_REPORTS}`
    return this.http.put(url, payload)
  }


  async createPdfPreview(blob: Blob, title: string, type: string, newTab?: string) {
    const arrayBuffer = await blob.arrayBuffer();
    const pdfDoc = await PDFDocument.load(arrayBuffer);

    // Embed metadata
    pdfDoc.setTitle(title);
    pdfDoc.setAuthor('TREO');

    const modifiedPdfBytes = await pdfDoc.save();
    const uint8Array = new Uint8Array(modifiedPdfBytes.buffer as ArrayBuffer);
    const modifiedBlob = new Blob([uint8Array], { type });

    // Create blob URL
    const blobUrl = URL.createObjectURL(modifiedBlob);

    // Open in current tab
    if (newTab === 'newTab') {
      const isNewTab = window.open('', '_blank');
      if (isNewTab) {
        isNewTab.location.href = blobUrl;
      }
    } else {
      window.location.href = blobUrl;
    }

    // Clean up
    setTimeout(() => URL.revokeObjectURL(blobUrl), 10000);
  }

  createHTMLPreview(blob: Blob, customTitle: string) {
    const reader = new FileReader();

    reader.onload = () => {
      let htmlContent = reader.result as string;

      // Replace or inject <title>
      htmlContent = htmlContent.replace(/<title>.*<\/title>/i, `<title>${customTitle}</title>`);
      if (!htmlContent.includes('<title>')) {
        htmlContent = htmlContent.replace(/<head>/i, `<head><title>${customTitle}</title>`);
      }

      const modifiedBlob = new Blob([htmlContent], { type: 'text/html' });
      const url = URL.createObjectURL(modifiedBlob);
      window.location.href = url;
    };

    reader.readAsText(blob);
  }

}


